import classNames from 'classnames';
import { PanelFooter, PanelHeader } from 'components/secondaryMarket/shared/status/Panel';
import { FC } from 'react';

export const PendingOrderSidePanel: FC<{ className?: string }> = ({ className }) => {
  return (
    <div className={classNames('d-flex flex-column overflow-y-auto', className)}>
      <PanelHeader color="warning" discreet />
      <PanelFooter
        color="warning"
        discreet
        statusKey="secondaryMarket.sidePanel.label.awaitingConfirmation"
        icon="hourglass_empty"
      />
    </div>
  );
};
PendingOrderSidePanel.displayName = 'PendingOrderSidePanel';
